import { BaseField } from './BaseField';

const imgGroup40428 = "/assets/03d7013dae5803e41b5fa764e4e054bf6aecb1cf.svg";

export class RoomsField extends BaseField {
  constructor() {
    super({
      key: 'rooms',
      icon: imgGroup40428,
      defaultLabel: 'Pokoje'
    });
  }

  getLabel(property, params = {}) {
    if (params.label) return params.label;
    return property.propertyType === 'lokal uslugowy' ? 'Pomieszczenia' : this.defaultLabel;
  }

  renderForList(property, params = {}) {
    const rooms = property.specifications.rooms;

    if (rooms.label) {
      return { label: this.getLabel(property, params), value: rooms.label };
    }

    return {
      label: this.getLabel(property, params),
      value: rooms.totalExtraVariant
        ? `${rooms.total} lub ${rooms.totalExtraVariant}`
        : rooms.total
    };
  }

  renderForCard(property, params = {}) {
    return this.renderForList(property, params);
  }
}
